import { loginUser } from '~/clientApis/userApi';
import { getStore } from '~/mobx/AppStore';

const submitLogin = async () => {
    const { loginPageStore } = getStore();

    if (!loginPageStore.username.trim() || !loginPageStore.password.trim()) {
        loginPageStore.setLoginErrorUserPwd(true);
        return;
    }
    loginPageStore.setLoginErrorUserPwd(false);

    loginPageStore.setIsLoggingIn(true);
    try {
        const result = await loginUser(loginPageStore.username, loginPageStore.password);

        if (result?.success) {
            // Login successful - redirect to homepage
            loginPageStore.setIsRedirecting(true);
            window.location.href = '/';
            return;
        } else {
            // Login failed
            loginPageStore.setLoginErrorUserPwd(true);
        }
    } catch {
        loginPageStore.setLoginErrorUserPwd(true);
    } finally {
        loginPageStore.setIsLoggingIn(false);
    }
};

export default submitLogin;
